import { render, staticRenderFns } from "./CompensationBoard.vue?vue&type=template&id=8992df30"
import script from "./CompensationBoard.vue?vue&type=script&lang=js"
export * from "./CompensationBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8992df30')) {
      api.createRecord('8992df30', component.options)
    } else {
      api.reload('8992df30', component.options)
    }
    module.hot.accept("./CompensationBoard.vue?vue&type=template&id=8992df30", function () {
      api.rerender('8992df30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/bulletinBoard/receivablesStatistics/CompensationBoard.vue"
export default component.exports